import { Spacer } from '@sparemin/blockhead';
import { LocationDescriptor } from 'history';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import {
  DestinationPlatform,
  DestinationPlatformsVideoTypes,
  getAudiogramPlatformsConfig,
} from 'blocks/DestinationPlatforms';
import { onOnboardingWizardNext } from 'redux/modules/mixpanel';
import { AudiogramVideoTypeConfig, AutogramVideoType } from 'types';
import { onboardingVideoTypeStepBlock as block } from '../utils';
import CardWizardStep from './CardWizard/CardWizardStep';

interface VideoTypeStepProps {
  platform?: DestinationPlatform;
  onProjectTypeSelected?: (
    videoType: AutogramVideoType,
    destination: LocationDescriptor,
  ) => void;
  onBackClick?: () => void;
}

function VideoTypeStep(props: VideoTypeStepProps) {
  const { platform, onProjectTypeSelected, onBackClick } = props;

  const dispatch = useDispatch<Dispatch>();

  const audiogramPlatformsConfig = getAudiogramPlatformsConfig();

  const handleVideoTypeSelected = useCallback(
    (videoType: AudiogramVideoTypeConfig) => {
      dispatch(
        onOnboardingWizardNext('videoTypes', {
          platform,
          videoType: videoType.id,
        }),
      );

      onProjectTypeSelected(
        videoType.wizardSettings.videoType,
        videoType.destination,
      );
    },
    [dispatch, onProjectTypeSelected, platform],
  );

  return (
    <CardWizardStep className={block()}>
      <Spacer
        as="div"
        orientation="vertical"
        align="center"
        justify="center"
        className={block('video-type-step-wrapper')}
      >
        <DestinationPlatformsVideoTypes
          icon={audiogramPlatformsConfig?.[platform]?.icon}
          videoTypes={audiogramPlatformsConfig?.[platform]?.videoTypes}
          onClick={handleVideoTypeSelected}
          onBackClick={onBackClick}
          listHeight={270}
        />
      </Spacer>
    </CardWizardStep>
  );
}

export default VideoTypeStep;
